<template>
  <page>
    <div slot="head" class="page-head-default" :style="{ 'padding-top': safeArea.top + 'px' }">
      <!-- 对齐 App：白底页面用黑色返回箭头 + 顶部 logo（logo_title.png 126.w） -->
      <img src="../../assets/imgs/icon_back.png" alt="" @click="onBack" />
      <img class="head_logo" src="../../assets/imgs/logo_title.png" alt="" />
    </div>
    <!-- 对齐 App login_phone：标题 textColor 26.sp + 填充式输入框 + 主题色 Login 按钮 + 第三方登录 -->
    <div class="login-phone-warp">
      <div class="page-title">{{ i18n.login_with_phone }}</div>
      <van-form @submit="onSendCode">
        <div class="login-row">
          <div class="area" @click="isAreaView = true">
            <span>+{{ areaCode }}</span>
            <div class="area-down"></div>
          </div>
          <input type="number" v-model="phone" :placeholder="i18n.phone_number" />
        </div>
        <div class="login-row">
          <input type="number" v-model="code" :placeholder="i18n.captcha_code" />
          <div class="login-code" @click="onCaptcha">
            <img :src="captchaUrl" />
          </div>
        </div>
        <div class="login-info">
          <span
            >{{ i18n.agree }}
            <span class="readme" @click="onReadMe">{{ i18n.readme }}</span>
          </span>
        </div>
        <van-button native-type="submit"></van-button>
        <div class="login-spacer"></div>
        <div class="btn" @click="onSendCode">{{ i18n.login }}</div>
        <!-- 对齐 App：第三方登录分割线 + Apple/Google 图标 -->
        <div class="login-foot">
          <div class="login-foot-tips">
            <span>{{ i18n.sign_in_with }}</span>
          </div>
          <div class="login-foot-imgs">
            <!-- 隐藏 Apple 登录入口（代码保留，需要时恢复） -->
            <!-- <login-apple @success="loadUser">
              <img src="../../assets/imgs/icon_apple_login.png" alt="" />
            </login-apple> -->
            <login-google @success="loadUser"></login-google>
          </div>
          <div class="login-foot-gap"></div>
        </div>
      </van-form>
    </div>
    <select-area v-model="isAreaView" @select="onSelct"></select-area>
    <login-code
      v-if="isLoginCode"
      @submit="onLogin"
      @again="onAgain"
      @back="onBackCode"
    ></login-code>
  </page>
</template>

<script>
import { SelectArea } from "../../components/select"
import { generateUUID } from "../../utils/index"
import { baseURL } from "../../utils/http"
import { USER_CAPTCHA, LOGIN_CODE, SEND_CODE, USER_INFO } from "../../apis/user"
import { LoginCode, LoginGoogle } from "../../components/login"
import { mapState } from "vuex"
export default {
  components: {
    SelectArea,
    LoginCode,
    LoginGoogle
  },
  computed: {
    ...mapState(["user", "safeArea"]),
    i18n() {
      return this.$t("login")
    }
  },
  watch: {
    user(val, oldVal) {
      if (val && !oldVal) {
        this.$router.push("/")
      }
    }
  },
  data() {
    return {
      isAreaView: false,
      areaCode: "234",
      phone: "",
      code: "",
      captchaUrl: "",
      uuid: "",
      isLoginCode: false
    }
  },
  methods: {
    onBack() {
      this.$router.push("/login")
    },
    onReadMe() {
      const VUE_APP_PACT = `${process.env.VUE_APP_DOMAIN}/content/user_agreement.html`
      window.open(VUE_APP_PACT)
    },
    onSelct(val) {
      this.areaCode = val
    },
    onCaptcha() {
      this.code = ""
      this.uuid = generateUUID()
      this.captchaUrl = `${baseURL}${USER_CAPTCHA}?uuid=${this.uuid}`
    },
    onLogin(code) {
      this.$loading(true)
      this.$post(
        LOGIN_CODE,
        {
          mobile: this.areaCode + this.phone,
          verifyCode: code,
          areaCode: this.areaCode,
          registAndLoginType: 1
        },
        (res) => {
          console.log(res)
          this.$loading(false)
          if (res.token) {
            this.$store.commit("token", res.token)
            this.loadUser()
          } else {
            this.$toast(this.i18n.msg_fail_login)
          }
        },
        (err) => {
          console.log(err)
          this.$loading(false)
        }
      )
    },
    onSendCode() {
      this.$loading(true)
      this.$post(
        SEND_CODE,
        {
          mobile: this.areaCode + this.phone,
          uuid: this.uuid,
          code: this.code,
          useDebug: false
        },
        (res) => {
          console.log(res)
          this.$loading(false)
          this.isLoginCode = true
        },
        (err) => {
          console.log(err)
          this.$loading(false)
          this.$toast(err)
          this.onCaptcha()
        }
      )
    },
    onAgain() {
      this.isLoginCode = false
      this.onCaptcha()
    },
    onBackCode() {
      this.isLoginCode = false
      this.onCaptcha()
    },
    loadUser() {
      this.$loading(true)
      this.$get(
        USER_INFO,
        {},
        (res) => {
          this.$loading(false)
          if (res.user) {
            this.$store.commit("user", res.user)
            this.$toast(this.i18n.msg_success_login)
          } else {
            this.$confirm({
              title: this.i18n.msg_fail_title,
              content: this.i18n.msg_fail_user
            })
              .then(() => {
                this.loadUser()
              })
              .catch(() => {
                this.$store.commit("token", null)
              })
          }
        },
        (err) => {
          this.$loading(false)
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: err,
            showCancel: false
          }).then(() => {
            this.$store.commit("token", null)
          })
        }
      )
    }
  },
  mounted() {
    this.onCaptcha()
  }
}
</script>

<style lang="less">
.login-phone-warp {
  padding: 0 56px;
  min-height: calc(100vh - 150px);
  display: flex;
  flex-direction: column;

  // 对齐 App login_phone：内容区标题 textColor 26.sp
  .page-title {
    padding: 157px 0 38px;
    font-size: 45px;
    color: var(--text-main);
  }

  .login-row {
    margin: 36px 0;
    height: 105px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    // 对齐 App login_phone：填充式输入框（itemColor 背景 + 圆角 14.w）
    background: var(--item-bg);
    border-radius: 24px;
    padding: 0 20px;
    box-sizing: border-box;

    .area {
      width: 100px;
      padding: 0 10px;
      display: flex;
      justify-content: space-around;
      align-items: center;
    }

    input {
      font-size: 32px;
      width: 300px;
      flex: 1;
      height: 80px;
      padding: 0 10px;
      margin: 0;
      border: none;
      outline: none;
      background-color: rgba(0, 0, 0, 0);
      color: var(--text-main);

      // 对齐 App 输入框提示色 hintTextColor(#C6C6C6)
      &::placeholder {
        color: var(--text-hint);
      }
    }

    .area-down {
      width: 0;
      height: 0;
      border-width: 10px 10px 0;
      border-style: solid;
      border-color: var(--text-main) transparent transparent;
    }

    .login-code {
      width: 180px;
      height: 60px;
      background-image: linear-gradient(
        to right,
        rgba(194, 194, 194, 1),
        rgba(252, 252, 252, 1)
      );

      img {
        width: 180px;
        height: 60px;
      }
    }
  }

  .btn {
    margin: 60px 0 0;
  }

  // 对齐 App：弹性空间，撑开按钮到底部
  .login-spacer {
    flex: 1;
  }

  .login-info {
    font-size: 24px;
    font-weight: 400;
    // 对齐 App：协议文字黑色
    color: var(--text-sub);
    line-height: 33px;
    display: flex;
    justify-content: flex-start;
  }

  .login-info .readme {
    font-weight: 500;
    // 对齐 App actionBlue(#267AFF)
    color: var(--text-link);
    margin-left: 10px;
    display: inline;
  }

  // 对齐 App _loginOtherWidget：分割线 + 第三方图标
  .login-foot {
    margin-top: 60px;

    &-tips {
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        // 对齐 App login_other：分割文字 color_fillColor(#000)
        color: var(--text-main);
        font-size: 28px;
        padding: 0 24px;
      }

      &::after,
      &::before {
        content: " ";
        flex: 1;
        height: 1px;
        // 对齐 App login_other：分割线 color_fillColor(#000)
        background-color: var(--text-main);
      }
    }

    &-imgs {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 24px;
      margin-top: 30px;

      // 不限制图标尺寸，原始图片大小显示
      img {
        max-width: 60px;
        height: auto;
      }
    }

    &-gap {
      height: 56px;
    }
  }
}
</style>
